import { useMutation } from '@tanstack/react-query';

const ENDPOINT = import.meta.env.DEV
  ? 'http://localhost:8080'
  : 'https://property-tax-api.yourwayhome.com';

interface Payload {
  clientEmailAddress: string;
  clientName: string;
  clientPhoneNumber?: string;
  agentEmailAddress: string;
  agentName: string;
  propertyAddress: string;
  propertyId: string;
  additionalInfo?: string;
  helpNeeded: string[];
}

export default function useRequestHelp() {
  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: Payload) => {
      const response = await fetch(`${ENDPOINT}/api/v1/common/email/help`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
  });
}
